var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_9411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.125 0H12.9727C13.4688 0 13.9453 0.199219 14.2969 0.550781L16.9492 3.20312C17.3008 3.55469 17.5 4.03125 17.5 4.52734V13.125C17.5 14.1602 16.6602 15 15.625 15H8.125C7.08984 15 6.25 14.1602 6.25 13.125V1.875C6.25 0.839844 7.08984 0 8.125 0ZM1.875 5H5V7.5H2.5V17.5H10V16.25H12.5V18.125C12.5 19.1602 11.6602 20 10.625 20H1.875C0.839844 20 0 19.1602 0 18.125V6.875C0 5.83984 0.839844 5 1.875 5Z",
    fill: "#43BBC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_9411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d974498226ca317598e60674422b3ab2.svg";
export { ForwardRef as ReactComponent };